module.exports = __webpack_public_path__ + "static/media/face_loading.8cf11d87.gif";